// extracted by mini-css-extract-plugin
module.exports = {"capsuleCardButtonPadding":"capsule-card_capsuleCardButtonPadding__XrGj9"};